<template>
  <div class="col-md-12 col-sm-12 pl-1 pr-1 pl-0 pr-0 col-lg-12 col-xl-12 baise parent yuanjiao p-3 mb-3 sjbdtop" style="min-height: 87vh;">
    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 pl-0 pr-0 sjbzt" style="font-size: calc(8px + 0.4vw);line-height: calc(15px + 0.5vw);">
      <form>
        <div class="form-group">
          <label style="font-weight: 500;"> <span style="color: red;">*</span>{{ $t('申請數量') }}</label>
          <div>
            <input style="background: #F6F4F0;border: none;font-size: calc(7px + 0.4vw);" v-model="form.number" type="yhm" class="form-control sjbxzt srk pl-3" :placeholder="$t('請輸入申請數量')">
          </div>
        </div>
        <div class="form-group">
          <label style="font-weight: 500;"> <span style="color: red;">*</span>{{ $t('聯絡人姓名') }}</label>
          <div>
            <input style="background: #F6F4F0;border: none;font-size: calc(7px + 0.4vw);" v-model="form.real_name" type="yhm" class="form-control sjbxzt srk pl-3" :placeholder="$t('請輸入聯絡人姓名')">
          </div>
        </div>
        <div class="form-group">
          <label style="font-weight: 500;"> <span style="color: red;">*</span>{{ $t('手機') }}</label>
          <div>
            <input style="background: #F6F4F0;border: none;font-size: calc(7px + 0.4vw);" v-model="form.phone" type="yhm" @input="validatePhone()" class="form-control sjbxzt srk pl-3" :placeholder="$t('請輸入手機')">
            <small class="form-text sjbxzt" style="color: red;" v-if="phoneError">{{ phoneError }}</small>
          </div>
        </div>

        <label style="font-weight: 500;"><span style="color: red;">*</span>{{ $t('抵達地') }}</label>
        <!-- 居住城市 -->
        <div class="col-sm-12 d-flex mb-3 pl-0 pr-0 justify-content-between align-item-center">
          <div class="pl-0 pr-0 col-sm-4">
            <div class=" col-sm-12 pl-0 pr-0">

              <div class="pl-0 pr-0 position-relative col-md-12 pl-0 pr-0">
                <!-- 触发Dropdown的按钮 -->
                <button class="d-flex ckqbb zhankai col-sm-12 dydpd pt-2 pb-2 pl-0 pr-0 " type="button" id="dropdownMenuButton" @click="gjtoggleDropdown()">
                  <div class="d-flex align-items-center justify-content-between col-md-12 pl-0 pr-0 sjbxxzt" style="font-size: calc(8px + 0.4vw);padding-left: calc(10px + 0.4vw) !important;padding-right: calc(10px + 0.4vw) !important">
                    <div>
                      {{ form.gj ?  form.gj : $t('请选择') }}
                    </div>
                    <div>
                      {{ $t('国家') }}
                      <img class="ml-1" style="width: calc(7px + 0.4vw);" src="@/img/daohangl/icon_xlcd_xljt@2x (1).png" alt="" />
                    </div>
                  </div>
                </button>
                <!-- Dropdown内容，使用v-show控制显示 -->
                <div class="dropdown-menu yuanjiao xlcd position-absolute col-sm-12 text-center" aria-labelledby="dropdownMenuButton" v-show="gjisDropdownOpen" style="border-radius:7px;background: #FFFAF0;">
                  <div v-for="(item, index) in guojialist" :key="index" class="dropdown-item xuazz yuanjiao sjbxzt mb-2" :style="{ 'background': guojiaid == item.id ? '#FFD672' : '' }" @click="gjxuanz(item.name, item.id)" href="#"> {{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class=" pl-0 pr-0 col-sm-4 pl-2">
            <div class=" col-sm-12 pl-0 pr-0">
              <div class="pl-0 pr-0 position-relative col-md-12 pl-0 pr-0">
                <!-- <label class="mt-3" style="font-weight: 500;"></label> -->
                <!-- 触发Dropdown的按钮 -->
                <button class="d-flex ckqbb zhankai col-sm-12 dydpd pt-2 pb-2 pl-0 pr-0" type="button" id="dropdownMenuButton" @click="xstoggleDropdown()">
                  <div class="d-flex align-items-center justify-content-between col-md-12 pl-0 pr-0 sjbxxzt" style="font-size: calc(8px + 0.4vw);padding-left: calc(10px + 0.4vw) !important;padding-right: calc(10px + 0.4vw) !important">
                    <div>{{ form.xs ? form.xs : $t('请选择') }}
                    </div>
                    <div>
                      {{ $t('县市') }}
                      <img class="ml-1" style="width: calc(7px + 0.4vw);" src="@/img/daohangl/icon_xlcd_xljt@2x (1).png" alt="" />
                    </div>
                  </div>
                </button>
                <!-- Dropdown内容，使用v-show控制显示 -->
                <div class="dropdown-menu yuanjiao xlcd position-absolute col-sm-12 text-center" aria-labelledby="dropdownMenuButton" v-show="xsisDropdownOpen" style="border-radius:7px;background: #FFFAF0;max-height: 250px;overflow-y: auto;">
                  <div v-for="(item, index) in xianslist" :key="index" class="dropdown-item xuazz sjbxzt yuanjiao mb-2" :style="{ 'background': xiansid == item.id ? '#FFD672' : '' }" @click="xsxuanz(item.name, item.id)" href="#">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class=" pl-0 pr-0 col-sm-4 pl-2">
            <div class=" col-sm-12 pl-0 pr-0">
              <!-- <label class="mt-3" style="font-weight: 500;"></label> -->
              <div class="pl-0 pr-0 position-relative col-md-12 pl-0 pr-0">
                <!-- 触发Dropdown的按钮 -->
                <button class="d-flex ckqbb zhankai col-sm-12 dydpd pt-2 pb-2 pl-0 pr-0" type="button" id="dropdownMenuButton" @click="qytoggleDropdown()">
                  <div class="d-flex align-items-center justify-content-between col-md-12 pl-0 pr-0 sjbxxzt" style="font-size: calc(8px + 0.4vw);padding-left: calc(10px + 0.4vw) !important;padding-right: calc(10px + 0.4vw) !important">
                    <div>{{ form.qy ? form.qy : $t('请选择') }}
                    </div>
                    <div>
                      {{ $t('区域') }}
                      <img class="ml-1" style="width: calc(7px + 0.4vw);" src="@/img/daohangl/icon_xlcd_xljt@2x (1).png" alt="" />
                    </div>
                  </div>
                </button>
                <!-- Dropdown内容，使用v-show控制显示 -->
                <div class="dropdown-menu yuanjiao xlcd position-absolute col-sm-12 text-center" aria-labelledby="dropdownMenuButton" v-show="qyisDropdownOpen" style="border-radius:7px;background: #FFFAF0;max-height: 250px;overflow-y: auto;">
                  <div v-for="(item, index) in quyulist" :key="index" class="dropdown-item xuazz sjbxzt yuanjiao mb-2" :style="{ 'background': quyuid == item.id ? '#FFD672' : '' }" @click="qyxuanz(item.name, item.id)" href="#">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div>
            <input style="background: #F6F4F0;border: none;font-size: calc(7px + 0.4vw);" v-model="form.arrive_address" type="yhm" class="form-control sjbxzt srk pl-3" :placeholder="$t('請輸入詳細地址')">
          </div>
        </div>
        <div class="form-group">
          <label class="sjbzt" style="font-weight: 500;font-size: calc(7px + 0.4vw);"><span style="color: red;">*</span>{{
						$t('物資用途') }}</label>
          <div>
            <b-form-textarea class="sjbxzt" style="background: #F6F4F0;border: none;font-size: calc(7px + 0.4vw);" id="textarea" v-model="form.usage_of_materials" :placeholder="$t('請輸入物資用途')" rows="3" max-rows="6" no-resize></b-form-textarea>
          </div>
        </div>
        <div v-if="leix==2" @click="bulletframe()" class="pl-4 pr-4 pt-2 pb-2 yuanjiao ckqbb sjbzt curpo mt-3" style="font-size: calc(6px + 0.4vw);background: #FFD672;width: calc(120px + 0.5vw);text-align: center;">
          {{ $t('提交申請') }}
          <span v-if="isLoading" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true">
          </span>
        </div>
        <div v-else class="pl-4 pr-4 pt-2 pb-2 yuanjiao ckqbb sjbzt curpo mt-3" style="font-size: calc(6px + 0.4vw);background: #f6f4f0;width: calc(120px + 0.5vw);text-align: center;">
          {{ $t('提交申請') }}
          <span v-if="isLoading" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true">
          </span>
        </div>
      </form>
    </div>
  </div>
</template>
  
  <script>
import { EventBus } from "@/views/event-bus.js";
import { region_list, user_info, user_save } from "@/request/zhbd/index.js";
import {
  sendcode,
  sendcodeemil,
  check_sms,
  check_email,
  login_check_username,
  login_check_email,
  login_check_phone,
  user_update_pwd,
  goods_apply_goods,
} from "@/request/api.js";

export default {
  components: {},
  data() {
    return {
      leix: localStorage.getItem("type"),
      modalShow: false,
      szyxdpd: true,
      dqname: "",
      dqemil: "",
      dqsjh: "",
      yzmqr: 1,
      emyzmqr: 1,
      yhmxzsr: "",
      yhmjzsr: false,
      ncjzsr: false,
      months: [],
      days: [],
      tianisDropdownOpen: false,
      youisDropdownOpen: false,
      nianisDropdownOpen: false,
      quyulist: [],
      xianslist: [],
      guojialist: [],
      ggyx: true,
      gghm: true,
      isLoading: false,
      emilError: "",
      phoneError: "",
      time: "",
      timeTrue: true, //判断验证码
      phonetime: "",
      phonetimeTrue: true, //判断验证码
      gjisDropdownOpen: false,
      xsisDropdownOpen: false,
      qyisDropdownOpen: false,
      guojiaid: "",
      xiansid: "",
      quyuid: "",
      form: {
        arrive_address: "",
        usage_of_materials: "",
        phone: "",
        real_name: "",
        number: "",
      },
    };
  },
  created() {},
  mounted() {
    this.region_list();
    this.gjxuanz("臺灣", 1)
  },
  computed: {},
  methods: {
    genggamm() {
      this.modalShow = true;
      this.qdpassword.password = "";
      this.qdpassword.ercpassword = "";
      this.qdpassword.yxianmm = "";
      this.tadshow = false;
    },
    cjxsjakw(e) {
      this.tadshow = true;
      const numberRegex = /\d/; // 匹配数字
      const lowercaseRegex = /[a-z]/; // 匹配小写字母
      const uppercaseRegex = /[A-Z]/; // 匹配大写字母
      const symbolRegex = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\;'\\[\]·~! @#￥‰….&*()-\-+={}|《》?:“”【】、;“,。、]/im;
      const startsWith09Regex = /^09[0-9]{8}$/; // 检查是否以 09 开头
      const chineseCharRegex = /[\u4e00-\u9fa5]/; // 检查是否包含汉字
      if (this.qdpassword.password.length < 8) {
        this.mmshow.bhzy = 1;
      }
      if (this.qdpassword.password.length >= 8) {
        this.mmshow.bhzy = 2;
      }
      if (!numberRegex.test(this.qdpassword.password)) {
        this.mmshow.zsygsz = 1;
      }
      if (numberRegex.test(this.qdpassword.password)) {
        this.mmshow.zsygsz = 2;
      }
      if (
        !lowercaseRegex.test(this.qdpassword.password) ||
        !uppercaseRegex.test(this.qdpassword.password) ||
        !symbolRegex.test(this.qdpassword.password)
      ) {
        this.mmshow.xxzmdx = 1;
      }
      if (
        lowercaseRegex.test(this.qdpassword.password) &&
        uppercaseRegex.test(this.qdpassword.password) &&
        symbolRegex.test(this.qdpassword.password)
      ) {
        this.mmshow.xxzmdx = 2;
      }
      if (
        startsWith09Regex.test(this.qdpassword.password) ||
        chineseCharRegex.test(this.qdpassword.password)
      ) {
        this.mmshow.mcsjhm = 1;
      }
      if (
        !startsWith09Regex.test(this.qdpassword.password) &&
        !chineseCharRegex.test(this.qdpassword.password)
      ) {
        this.mmshow.mcsjhm = 2;
      }
    },
    handleBlur() {
      if (this.mmshow.bhzy == 1) {
        this.mmshow.bhzy = 3;
      }
      if (this.mmshow.zsygsz == 1) {
        this.mmshow.zsygsz = 3;
      }
      if (this.mmshow.xxzmdx == 1) {
        this.mmshow.xxzmdx = 3;
      }
      if (this.mmshow.mcsjhm == 1) {
        this.mmshow.xxzmdx = 3;
      }
    },
    updateMonthsAndDays() {
      this.months = this.monthsComputed;
      this.days = this.daysComputed;
    },
    async region_list(e) {
      const { data } = await region_list({
        parent_id: 0,
      });
      this.guojialist = data.data;
    },
    tianxuanz(e) {
      this.selectedDay = e;
      this.tianisDropdownOpen = false;
    },
    tiantoggleDropdown() {
      this.tianisDropdownOpen = !this.tianisDropdownOpen;
      this.nianisDropdownOpen = false;
      this.youisDropdownOpen = false;
      this.gjisDropdownOpen = false;
      this.xsisDropdownOpen = false;
      this.qyisDropdownOpen = false;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
    youxuanz(e) {
      this.selectedMonth = e;
      this.updateMonthsAndDays();
      this.youisDropdownOpen = false;
    },
    youtoggleDropdown() {
      this.youisDropdownOpen = !this.youisDropdownOpen;
      this.tianisDropdownOpen = false;
      this.nianisDropdownOpen = false;
      this.gjisDropdownOpen = false;
      this.xsisDropdownOpen = false;
      this.qyisDropdownOpen = false;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
    nianxuanz(e) {
      this.selectedYear = e;
      this.updateMonthsAndDays();
      this.nianisDropdownOpen = false;
    },
    niantoggleDropdown() {
      this.nianisDropdownOpen = !this.nianisDropdownOpen;
      this.youisDropdownOpen = false;
      this.tianisDropdownOpen = false;
      this.gjisDropdownOpen = false;
      this.xsisDropdownOpen = false;
      this.qyisDropdownOpen = false;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
    // 点击
    async bulletframe() {
      if (this.form.number == "") {
        this.$bvToast.toast(this.$t("請輸入申請數量"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      } else if (this.form.real_name == "") {
        this.$bvToast.toast(this.$t("請輸入聯絡人姓名"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      } else if (this.form.phone == "") {
        this.$bvToast.toast(this.$t("請輸入手機"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      } else if (
        this.guojiaid == "" ||
        this.xiansid == "" ||
        this.quyuid == ""
      ) {
        this.$bvToast.toast(this.$t("請輸入抵達地"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      } else if (this.form.usage_of_materials == "") {
        this.$bvToast.toast(this.$t("請輸入物資用途"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      }
      const { msg, code } = await goods_apply_goods({
        id: this.$route.params.id,
        arrive_address: this.form.arrive_address,
        usage_of_materials: this.form.usage_of_materials,
        phone: this.form.phone,
        real_name: this.form.real_name,
        number: this.form.number,
        arrive_region_id: this.guojiaid,
        arrive_city_id: this.xiansid,
        arrive_district_id: this.quyuid,
      });
      if (code == 200) {
        this.$bvToast.toast(this.$t("提交成功"), {
          title: this.$t("login.notice"),
          autoHideDelay: 2000,
          delay: 5000,
          appendToast: true,
          variant: "success",
        });
        setTimeout(() => {
          this.$router.go(-1);
        }, 1000);
      } else {
        this.$bvToast.toast(msg, {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
      }
    },
    // 校验验证码
    async validatePhone() {
      this.form.phoneuse = "";
      this.yzmqr = 1;
      this.phonetimeTrue = true;
      const regex = /^09[0-9]{8}$/;
      if (!regex.test(this.form.phone)) {
        this.phoneError = this.$t("⼿機號瑪格式錯誤");
      } else {
        this.phoneError = "";
      }
      if (this.form.phone == "") {
        this.phoneError = "";
      }
    },
    yhncjzsrsjh() {
      const regex = /^09[0-9]{8}$/;
      if (regex.test(this.form.yhnc)) {
        this.ncjzsr = true;
      } else {
        this.ncjzsr = false;
      }
    },
    async jzsrsjih(event) {
      this.yhmjzsr = false;
      this.form.yhm = this.form.yhm.trim();
      const regex = /^09[0-9]{8}$/;
      const sjixsz = /[^a-zA-Z0-9]/g;
      if (sjixsz.test(this.form.yhm) || regex.test(this.form.yhm)) {
        this.yhmjzsr = true;
        this.yhmxzsr = sjixsz.test(this.form.yhm)
          ? this.$t("用户名仅限数字与英文！")
          : this.$t("为了隐私安全，请不用以手机号码作为用户名！");
      } else {
        if (this.dqname == this.form.yhm) {
          this.yhmjzsr = false;
        } else {
          const { data, code } = await login_check_username({
            username: this.form.yhm,
          });
          if (data.is_registered == 1) {
            console.log(123);
            this.yhmjzsr = true;
            this.yhmxzsr = this.$t("用戶帳號已經註冊");
          } else {
            this.yhmjzsr = false;
          }
        }
      }
    },
    // 获取验证码
    async phoneobtainCode() {
      if (this.phoneError != "") {
        return;
      } else if (this.form.phone == "") {
        this.$bvToast.toast(this.$t("login.qsryx"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      }
      this.$bvToast.toast(this.$t("login.verification_success"), {
        title: this.$t("login.notice"),
        autoHideDelay: 2000,
        delay: 5000,
        appendToast: true,
        variant: "success",
      });
      this.phoneacquire();
      const { msg, code } = await sendcode({
        phone: this.form.phone,
      });
      if (code == 200) {
      } else {
        this.$bvToast.toast(msg, {
          title: this.$t("login.warning"),
          autoHideDelay: 2000,
          delay: 5000,
          appendToast: true,
          variant: "danger",
        });
      }
    },
    // 验证码获取成功
    phoneacquire() {
      this.phonetimeTrue = false;
      this.phonetime = 60;
      var setTimeoutS = setInterval(() => {
        this.phonetime--;
        if (this.phonetime <= 0) {
          clearInterval(setTimeoutS);
          this.phonetimeTrue = true;
        }
      }, 1000);
    },
    async gjxuanz(e, v) {
      this.form.gj = e;
      this.guojiaid = v;
      const { data } = await region_list({
        parent_id: v,
      });
      this.xianslist = data.data;
      this.quyuid = "";
      this.form.qy = "";
      this.quyulist = [];
      this.gjisDropdownOpen = false;
    },
    gjtoggleDropdown() {
      this.gjisDropdownOpen = !this.gjisDropdownOpen;
      this.xsisDropdownOpen = false;
      this.qyisDropdownOpen = false;
      this.nianisDropdownOpen = false;
      this.youisDropdownOpen = false;
      this.tianisDropdownOpen = false;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
    async xsxuanz(e, v) {
      this.form.xs = e;
      this.xiansid = v;
      const { data } = await region_list({
        parent_id: v,
      });
      this.quyulist = data.data;
      this.xsisDropdownOpen = false;
    },
    xstoggleDropdown() {
      this.xsisDropdownOpen = !this.xsisDropdownOpen;
      this.gjisDropdownOpen = false;
      this.qyisDropdownOpen = false;
      this.nianisDropdownOpen = false;
      this.youisDropdownOpen = false;
      this.tianisDropdownOpen = false;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
    qyxuanz(e, v) {
      this.form.qy = e;
      this.quyuid = v;
      this.qyisDropdownOpen = false;
    },
    qytoggleDropdown() {
      this.qyisDropdownOpen = !this.qyisDropdownOpen;
      this.xsisDropdownOpen = false;
      this.gjisDropdownOpen = false;
      this.nianisDropdownOpen = false;
      this.youisDropdownOpen = false;
      this.tianisDropdownOpen = false;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
  },
};
</script>
  
  <style scoped>
@media screen and (max-width: 991px) {
  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }
  .sjbdtop {
    margin-top: 1rem !important;
  }
  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }
  .sjbxxzt {
    font-size: calc(9px + 0.4vw) !important;
  }
  .paddlef {
    padding-left: 40px !important;
  }
  .heggs {
    height: 73svh !important;
  }
}
/* 隐藏水平滚动条 */
.parent::-webkit-scrollbar {
  display: none;
}

textarea.form-control {
  overflow-y: auto !important;
}

.dcbd:hover {
  transform: scale(1.2);
}

.ckqbb:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.xlcd {
  display: block;
  background: #ffebd2;
  border: none;
}
.dropdown-menu {
  min-width: calc(25px + 0.5vw) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
/* 隐藏水平滚动条 */
.xlcd::-webkit-scrollbar {
  display: none;
}

.xuazz:hover {
  background: #ffebd2;
}

.zhankai {
  background: #ffebd2;
  text-align: center;
  border-radius: 12px 12px 12px 12px;
  border: none;
  font-weight: 400;
  font-size: calc(6px + 0.4vw);
  color: #1a1a1a;
}

textarea.form-control {
  overflow-y: auto !important;
}

.yzm {
  height: 27px;
  line-height: 27px;
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  color: #1a1a1a;
  background: #ffd672;
  border-radius: 12px;
  padding: 0 12px;
}
.annys {
  font-size: calc(6px + 0.4vw);
  background: #ffd672;
  width: 144px;
  margin: auto;
  border: none;
}
.dropdown-item{
  text-align: left;
}
</style>